"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const Checkbox_1 = __importDefault(require("../../../Checkbox"));
const RadioGroup_1 = require("../../../RadioGroup");
const constants_1 = require("../../constants");
const useTableColumnFilter = ({ columnDefinitions, showColumns, disableRowSelect, disableExpand, multiSelect, isItemDisabled, }) => {
    return react_1.useMemo(() => {
        const columnsFiltered = columnDefinitions.filter((column) => showColumns[column.id || '']);
        if (!disableExpand) {
            columnsFiltered.unshift({
                id: constants_1.EXPANDER_COLUMN_NAME,
                Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (react_1.default.createElement("span", Object.assign({}, getToggleAllRowsExpandedProps()), isAllRowsExpanded ? react_1.default.createElement(ExpandMore_1.default, null) : react_1.default.createElement(ChevronRight_1.default, null))),
                Cell: ({ row }) => row.canExpand ? (react_1.default.createElement("span", Object.assign({}, row.getToggleRowExpandedProps()), row.isExpanded ? react_1.default.createElement(ExpandMore_1.default, null) : react_1.default.createElement(ChevronRight_1.default, null))) : null,
            });
        }
        if (!disableRowSelect) {
            columnsFiltered.unshift({
                id: constants_1.SELECTION_COLUMN_NAME,
                width: 50,
                defaultCanFilter: false,
                disableFilters: true,
                disableGlobalFilter: true,
                Header: (props) => {
                    return multiSelect && !isItemDisabled ? (react_1.default.createElement(Checkbox_1.default, Object.assign({ controlId: `${constants_1.SELECTION_COLUMN_NAME}_all`, ariaLabel: "Checkbox to select all row items" }, props.getToggleAllRowsSelectedProps()))) : null;
                },
                Cell: ({ row, toggleAllRowsSelected }) => {
                    const isSelectDisabled = !!(isItemDisabled === null || isItemDisabled === void 0 ? void 0 : isItemDisabled(row.original));
                    return (react_1.default.createElement("div", null, multiSelect ? (react_1.default.createElement(Checkbox_1.default, Object.assign({ ariaLabel: "Checkbox to select row item" }, row.getToggleRowSelectedProps(), { disabled: isSelectDisabled, "data-testid": row.id, controlId: row.id }))) : (react_1.default.createElement(RadioGroup_1.RadioButton, { name: "select", checked: row.isSelected, controlId: row.id, "data-testid": row.id, disabled: isSelectDisabled, onChange: () => {
                            toggleAllRowsSelected(false);
                            row.toggleRowSelected(true);
                        } }))));
                },
            });
        }
        return columnsFiltered;
    }, [columnDefinitions, showColumns, disableRowSelect, disableExpand, multiSelect, isItemDisabled]);
};
exports.default = useTableColumnFilter;
//# sourceMappingURL=index.js.map